import { defineComponent } from 'vue'
import classNames from 'classnames'
import './Page.layout.scss'

export const PageLayout = defineComponent({
  name: 'PageLayout',
  inheritAttrs: false,
  setup(_props, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('page-layout', attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
